export default __webpack_public_path__ + "static/SCROLL_5-a93969410ccdcff92218bb2cf0f8a37b.png";